import React, { useState } from "react";
import { loginUser } from "services/authUser";
import { useHistory } from "react-router-dom";
import "./Login.scss";
import Buttons from "components/UI/Button/Buttons";
import { VisibilityMaterialIcon } from "Icons/MaterialIcons";
import { VisibilityOffMaterialIcon } from "Icons/MaterialIcons";

const Login = ({ setAuth }) => {
	const history = useHistory();
	const [email, setEmail] = useState("");
	const [pass, setPass] = useState("");
	const [mailErrorMessage, setMailErrorMessage] = useState("");
	const [passErrorMessage, setPassErrorMessage] = useState("");
	const [viewPassword, setViewPassword] = useState(false);

	if (window.localStorage.getItem("account") === "true") {
		history.push("/panel-control");
	}
	
	// console.log(loggedInUser());

	const handleSubmit = async (e) => {
		e.preventDefault();
		const { code, state } = await loginUser(email, pass);
		setAuth(state);
		window.localStorage.setItem("account", state);
		if (state === true) {
			history.push("/panel-control");
		}
		if (code === "auth/wrong-password") {
			setPassErrorMessage("La contraseña es incorrecta");
			setMailErrorMessage("");
			setPass("");
		}
		if (code === "auth/too-many-requests") {
			setPassErrorMessage("Demasiados intentos, pruebe en otro momento");
			setMailErrorMessage("");
			setPass("");
		}
		if (pass === "") {
			setPassErrorMessage("Debe introducir su contraseña");
			setMailErrorMessage("");
		}
		if (code === "auth/user-not-found") {
			setMailErrorMessage(
				"No se ha encontrado la dirección de correo electrónico"
			);
			setPassErrorMessage("");
		}
	};

	const onChangeEmail = (e) => setEmail(e.target.value);
	const onChangePassword = (e) => setPass(e.target.value);

	return (
		<>
			<h2 className="titleForm">Ingresar como Administrador</h2>
			<form onSubmit={handleSubmit} className="loginForm">
				<label htmlFor="email">Ingrese su correo electrónico</label>
				<input
					type="email"
					value={email}
					onChange={onChangeEmail}
					name="email"
					placeholder="ejemplo@dominio.com"
				/>
				<span className="loginForm__errorMessage">{mailErrorMessage}</span>
				<label htmlFor="pass">Ingrese su contraseña</label>
				<span className="password">
					<input
						type={viewPassword ? "text" : "password"}
						value={pass}
						onChange={onChangePassword}
						name="pass"
						className="inputPass"
						placeholder="contraseña"
					/>
					{viewPassword ? (
						<a className="controlPass" onClick={() => setViewPassword(false)}>
							<VisibilityMaterialIcon />
						</a>
					) : (
						<a className="controlPass" onClick={() => setViewPassword(true)}>
							<VisibilityOffMaterialIcon />
						</a>
					)}
				</span>
				<span className="loginForm__errorMessage">{passErrorMessage}</span>
				<Buttons
					onClick={handleSubmit}
					className="info__btn--branchOffices btnPrimary"
					type="submit"
				>
					Ingresar
				</Buttons>
			</form>
		</>
	);
};

export default Login;
